<template>
  <VModal ref="dialog" :disable-backdrop-click="pending" @close="$emit('close')">
    <template #default="modalProps">
      <div class="rounded shadow-xs w-full max-w-lg mx-auto">
        <div class="rounded shadow-lg bg-white">
          <div class="px-4 sm:px-6 py-5 border-b">
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h1 class="text-sm">Remove role</h1>
              </div>

              <div class="flex-none">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="modalProps.close"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="inline-flex h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="p-4 sm:p-6 space-y-8">
            <div class="space-y-6">
              <p>
                You are about to remove <b>{{ roleName }}</b> from this account. Are you sure?
              </p>
              <BaseFormInlineMessage v-if="errorMessage" danger>{{
                errorMessage
              }}</BaseFormInlineMessage>
            </div>

            <div class="flex gap-3 justify-end">
              <BaseButton type="button" primary :disabled="pending" @click="handleRemove">
                Yes, remove
              </BaseButton>
              <BaseButton type="button" ghost :disabled="pending" @click="modalProps.close()">
                Cancel
              </BaseButton>
            </div>
          </div>
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import { rolesClient } from '@/api/clients';

export default {
  props: {
    role: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pending: false,
      errorMessage: '',
    };
  },
  computed: {
    roleName() {
      return this.role?.name || 'Unknown';
    },
  },
  methods: {
    handleRemove() {
      this.pending = true;
      this.errorMessage = '';
      return rolesClient
        .delete(this.role.id)
        .then(() => {
          this.$emit('deleted');
          this.$refs.dialog?.close();
        })
        .catch((error) => {
          this.errorMessage = error.message;
        })
        .finally(() => {
          this.pending = false;
        });
    },
  },
};
</script>
